import { Heading, Stack, Text, Link } from '@chakra-ui/react'
import { StepsSection47Props } from '../utils/types'

export const StepsSection47 = ({
  stages,
  stagesCount,
}: StepsSection47Props) => {
  return (
    <Stack spacing={4}>
      <Heading fontSize='md'>47 Steps</Heading>
      <Text>
        Did you complete or start any of the
        {stages ? ' ' + (stages.length - 1) : ''} available Steps from
        HealingALS.org this month?
        {stages && stages.length < stagesCount + 1
          ? ' More steps are coming soon!'
          : ''}
      </Text>
      <Link
        href='https://healingals.org/47-steps/'
        isExternal
        color='purple.600'
      >
        Visit 47 Steps to Healing
      </Link>
    </Stack>
  )
}
